import { useEffect, useState } from 'react';
import { assignProductToDosageDiary } from '../service/assignProductToDosageDiary';
import showToast from '../components/ToastComponent';

export function useToAssignDosageDiary(
  token: string,
  profileId: string,
  setCounter: () => void,
) {
  const [products, setProducts] = useState<Array<number>>([]);

  useEffect(() => {
    if (!products.length) return;

    assignProductToDosageDiary(token, {
      profileId,
      productList: products,
    }).then((res) => {
      if (typeof res === 'number') {
        showToast({
          type: 'success',
          message: 'Products assigned successfully',
        });
        setCounter();
        return;
      }

      showToast({ type: 'info', message: res });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [products]);

  function updateProductList(list: Array<number>) {
    setProducts((p) => [...new Set([...p, ...list])]);
  }

  return [updateProductList];
}
